import { IntakeFormCustomQuestionAnswer } from 'types/IntakeForm';
import { Relationship } from 'types/MasterData';
import { Pet } from 'types/Pet';

export const emptyCustomer = (channel: string): Customer => ({
    id: undefined,
    name: '',
    lastName: '',
    email: '',
    phone: '',
    channel,

    lead: true,
    active: true,
    blocked: false,
    depositEligible: false,

    clientSince: null,
    conversionSource: null,

    smsMarketingOptIn: false,

    pets: []
});

export interface Customer {
    id?: number;

    name: string;
    token?: string;
    lastName: string;

    email: string;
    phone?: string;
    channel?: string;

    lead: boolean;
    active: boolean;
    blocked: boolean;

    /**
     * Whether this customer may be asked for a booking deposit. Precomputed by
     * the server from the marketplace's deposit configuration and its
     * new-clients-only setting; treat as authoritative and do not re-derive.
     */
    depositEligible: boolean;

    leadSource?: LeadSource;
    leadStage?: LeadStage;
    clientSince?: string | null;
    conversionSource?: null;

    smsMarketingOptIn?: boolean;

    pets: Array<Pet>;
    addresses?: Array<CustomerAddress>;
    emergencyContacts?: Array<EmergencyContact>;
    answers?: Array<IntakeFormCustomQuestionAnswer>;
}

export enum LeadSource {
    INTAKE_FORM = 'intake_form'
}

export enum LeadStage {
    NEW = 'new'
}

export enum CustomerChannel {
    ONLINE_BOOKING = 'online_booking',
    INTAKE_FORM = 'intake_form'
}

export interface CustomerAddress {
    id?: number;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    addressLineOne: string;
    addressLineTwo?: string;
    active: boolean;
    main?: boolean;
}

export interface EmergencyContact {
    uuid: string;
    phone: string;
    name: string;
    lastName: string;
    relationship: Relationship;
}
